// Environment
export const ENV = process.env.NODE_ENV ?? ''

// Settings
export const APP_MODE = process.env.VUE_APP_MODE ?? ''
export const APP_NAME = process.env.VUE_APP_NAME ?? ''

// API urls
export const URL_API = process.env.VUE_APP_URL_API ?? ''
export const URL_API_ONBOARDING = `${URL_API}/onboarding/rpc`
export const URL_API_APPEVENT = `${URL_API}/appevent/rpc`
export const URL_API_RELATIONS = `${URL_API}/relations/rpc`
export const URL_API_PAYMENT = `${URL_API}/payment/rpc`
export const URL_API_LINK = `${URL_API}/link`
export const URL_API_ASSETS = `${URL_API}/onboarding/assets`
export const URL_API_CC = `${URL_API}/onboarding/cc`

// Other urls
export const URL_TERMS = process.env.VUE_APP_URL_TERMS ?? ''
export const URL_UPDATE_APP = process.env.VUE_APP_URL_UPDATE_APP ?? ''
export const URL_SHARE_APP = process.env.VUE_APP_URL_SHARE_APP ?? ''
export const URL_OTA_LATEST = process.env.VUE_APP_URL_OTA_LATEST ?? ''
export const URL_CDN = process.env.VUE_APP_URL_CDN ?? ''

// Hosts
export const HOST_APP = process.env.VUE_APP_HOST_APP ?? ''
export const HOST_OPEN = process.env.VUE_APP_HOST_OPEN ?? ''
